//Knowledge center input output etc tabs
$(function(){
  $('.triggerClick').click(function(){
		$('.toggle__item').removeClass('is-active');

    var hashfound = $(this).data('hreftag')
		$('#knowledge__overview--wrapper').hide();
		$('#knowledge__insights--wrapper').hide();
		$('#knowledge__outputs--wrapper').hide();
		$('#knowledge__impacts--wrapper').hide();
		$(hashfound).parent().addClass('is-active');
		$(hashfound+'--wrapper').show();

  });
});


//Color change for the homepage
$('.toggle__item a').click(function(e){
  e.preventDefault();
  if (!$(this).parent().hasClass('is-active')) {
		$('.toggle__item').removeClass('is-active');
		$(this).parent().addClass('is-active');

		if($('#knowledge__toggle').length) {
			 var tab = $(this).attr("id");
			 $("#knowledge__overview--wrapper, #knowledge__insights--wrapper, #knowledge__outputs--wrapper, #knowledge__impacts--wrapper").hide();
			 $("#"+tab+"--wrapper").show();
		}
  }
});

//Knowledge centre recent and popular tab change
$('.tabbed ul li').click(function(){
	var iditem = $(this).attr('id');
	$('.tabbed ul li').removeClass('tabbed__active');
	$(this).addClass('tabbed__active');
	$('.knowledge__resource--cards').hide();
	$('.'+iditem).show();
});



// WEBPACK FOOTER //
// ./src/js/tabbedContent.js